<div class="acquisition-info">
  <div class="tool-btn-container">
    <ng-container *ngIf="isEditable && !editMode">
      <button
        mat-icon-button
        class="btn btn-flat-primary"
        [matTooltip]="'tooltip.edit_case_data' | translate"
        [matTooltipShowDelay]="1000"
        #editTooltip="matTooltip"
        (mouseleave)="editTooltip.hide()"
        (click)="editionMode.emit(true)"
      >
        <i class="ri-pencil-line"></i>
      </button>
    </ng-container>
    <ng-container *ngIf="editMode">
      <button mat-icon-button class="btn btn-outline-danger border-0" (click)="onDiscard()">
        <i class="ri-close-fill"></i>
      </button>
      <button
        mat-icon-button
        class="btn btn-flat-primary"
        [matTooltip]="'tooltip.save_case_data' | translate"
        [matTooltipShowDelay]="1000"
        #saveTooltip="matTooltip"
        (mouseleave)="saveTooltip.hide()"
        (click)="onSave()"
      >
        <i class="ri-save-2-line"></i>
      </button>
    </ng-container>
  </div>
  <div *ngFor="let field of fields; trackBy: trackByFieldPath" class="field-container">
    <div class="key">{{ field.displayName | titlecase }}:</div>
    <div class="value">
      <ng-container *ngIf="!editMode; else editable">
        <span>{{ field.value }}</span>
      </ng-container>
      <ng-template #editable>
        <input mat-input [(ngModel)]="field.value" (ngModelChange)="onFieldChange(field, $event)" />
      </ng-template>
    </div>
  </div>
</div>
